import axios from "axios";
import * as XLSX from "xlsx";
import { Role, Status } from "../../Redux/Actions/Role";
import moment from "moment";
import { InvoiceReceivedModel } from "./ReportsModel";

//Invoice Received Api Methods
export const getsetInvoiceReceivedData = async (setInvoiceReceived) => {
  await axios({
    method: "get", //you can set what request you want to be
    // url: `${`http://genialdemo-001-site9.itempurl.com`}/api/Authenticate/getUserRolesById`,
    url: `${process.env.REACT_APP_API_URL}/api/Reports/getInvoiceReceived`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
  })
    .then(async (res) => {
      const mappedData = res.data.map((item) => new InvoiceReceivedModel(item));
      setInvoiceReceived(mappedData);
    })
    .catch((err) => {});
};

export const getDemandTypes = async(
  setMultipleData
) =>{

  const dummyDemandTypes = [
    "Material",
    "Spare Parts",
    "Deposit",
    "Sample"
  ]
    await axios({
    method: "get", //you can set what request you want to be
    url: `${process.env.REACT_APP_API_URL}/api/Report/getDemandTypeList`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      "Content-Type": "application/json",
    },
    
  })
    .then(async (res) => {
      setMultipleData((pre) => ({
        ...pre,
        demandTypes: res?.data?.demandType,
      }));
     
    })
    .catch((err) => {
       
    });
  }
//Invoice Received Functions
